module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daylightrain-e4b308dd2fd4e230da58aa5979be4351.png";